import { createFileRoute } from '@tanstack/react-router';
import { checklistListQuery } from '../../api/checklists.ts';
import { ChecklistsPage } from '../../features/checklists/checklists-page.tsx';

// Checklist overview (T28): cadence, signer and newest run of every checklist this person sees.
export const Route = createFileRoute('/_authed/checklists/')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(checklistListQuery());
  },
  component: ChecklistsPage,
});
